/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
   window.addEventListener('load', function () {

    if (window.location.href.includes('#stockists')) {
     setTimeout(function () {
       // console.log(document.querySelector(window.location.hash))
       document.querySelector('html,body').animate({
         scrollTop: document.querySelector('#stockists').offset().top
       });
     }, 2000);
    }
  }, false);

  /**
 * Gets the option index that is different between `variant` in `previousVariant`.
 *
 * @param {object} variant
 * @param {object} previousVariant
 * @returns {1 | 2 | 3}
 */
 const getChangedOptionIndex = (variant, previousVariant) => {
   for (let i = 0; i < variant.options.length; i++) {
     if (variant.options[i] !== previousVariant.options[i]) {
       return i;
     }
   }
   return undefined; // return undefined if no option has changed
 };

 if (document.querySelector('.ProductForm__Variants')) {

   /**x
    * Find a variant via its options.
    *
    * @param {object[]} variants
    * @param {{ option1?: string, option2?: string, option3?: string }} options
    * @returns {object | undefined}
    */
   const findVariantByOptions = (variants, options) => {
     return variants.find((variant) =>
       (!options.option1 || variant.option1 === options.option1) &&
       (!options.option2 || variant.option2 === options.option2) &&
       (!options.option3 || variant.option3 === options.option3)
     );
   };

   const { product } = JSON.parse(document.querySelector('script[data-product-json]').innerHTML);

   document.addEventListener('variant:changed', (event) => {
     if (!event.detail.variant) return;

     const { variant, previousVariant } = event.detail;
     const changedOptionIndex = getChangedOptionIndex(variant, previousVariant);

     if (changedOptionIndex === undefined) return;

     const optionInputEls = document.querySelectorAll('input[name^="option-"]');

     optionInputEls.forEach((optionInputEl) => {
       const optionIndex = Number(optionInputEl.name.split('-')[1]);

       if (optionIndex !== changedOptionIndex) {
         const optionsToCheck = {
           [`option${changedOptionIndex + 1}`]: variant.options[changedOptionIndex],
           [`option${optionIndex + 1}`]: optionInputEl.value,
         };

         const foundVariant = findVariantByOptions(product.variants, optionsToCheck);

         if (!foundVariant || !foundVariant.available) {
           optionInputEl.nextElementSibling.classList.add('opt-sold-out');
         } else {
           optionInputEl.nextElementSibling.classList.remove('opt-sold-out');
         }
       }
     });
   });
 }

// Adding state to Labels// Adding state to Labels
function updateHasContentClass(container) {
  Array.from(container.children).forEach(el => {
    // Check if the element contains any visible content
    const hasVisibleContent = /\S/.test(el.textContent);  // \S matches any non-whitespace character

    // If the element contains visible content (anything other than just whitespace), add 'has-content'
    if (hasVisibleContent || el.querySelector('.ProductItem__Label')) {
      el.classList.add('has-content');
      el.classList.remove('no-content');
    } else {
      // If the element contains only whitespace (or is empty), remove 'has-content' and add 'no-content'

      el.classList.remove('has-content');
      el.classList.add('no-content');
    }
  });
}


// Initialize MutationObserver
function observeLabelContainer(container) {
  const observer = new MutationObserver(() => {
    updateHasContentClass(container);
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    characterData: true // Ensure text content changes are observed
  });

  // Initial update
  updateHasContentClass(container);
}

// Apply observer to all .ProductItems__LabelContainer elements
function applyObserverToAllContainers() {
  document.querySelectorAll('.ProductItems__LabelContainer').forEach(container => {
    observeLabelContainer(container);
  });

  // Monitor for new .ProductItems__LabelContainer elements added dynamically
  const globalObserver = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches('.ProductItems__LabelContainer')) {
            observeLabelContainer(node);
          }
        });
      }
    });
  });

  // Observe the body for added containers
  globalObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Start observing right away
applyObserverToAllContainers();

// Wrapping pushState and replaceState to detect changes
(function() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  // Detect changes when pushState is used
  history.pushState = function(state, title, url) {
    const result = originalPushState.apply(history, arguments);
    window.dispatchEvent(new Event('urlchange')); // Custom event when URL changes
    return result;
  };

  // Detect changes when replaceState is used
  history.replaceState = function(state, title, url) {
    const result = originalReplaceState.apply(history, arguments);
    window.dispatchEvent(new Event('urlchange')); // Custom event when URL changes
    return result;
  };
})();


// Listen for URL changes and rerun applyObserverToAllContainers()
window.addEventListener('urlchange', () => {
  // console.log('updates');

  // Set a delay (e.g., 500ms) before running the observer
  setTimeout(() => {
    applyObserverToAllContainers();
  }, 1000); // Delay of 500 milliseconds (adjust as needed)
});



function showQBSizeList(selectedColorInput, product) {
  if (selectedColorInput) {
    const selectedColor = selectedColorInput.value;
    product.querySelectorAll('.quick-buy-simple .HorizontalList__Item').forEach(item => {
      if (item.dataset.color === selectedColor) {
        item.style.display = 'inline-block';
      } else {
        item.style.display = 'none';
      }
    });
  }
}

function showListButton(listButton){
  listButton.classList.add('hidden');
  const quickBuyList = listButton.parentElement.querySelector('.quick-buy-list');
  quickBuyList.classList.remove('hidden');
  quickBuyList.classList.add('is-active');
}


document.addEventListener('DOMContentLoaded', function() {
  // Ensure that all the ProductItems are processed
  document.querySelectorAll('.ProductItem').forEach(product => {
    const selectedColorInput = product.querySelector('.ProductItem__ColorSwatchItem input:checked');
    showQBSizeList(selectedColorInput, product);
    product.addEventListener('change', event => {
      if (event.target.matches('.ProductItem__ColorSwatchItem input')) {
        // document.querySelector('.quick-buy-mobile').classList.remove('is-active');
        product.querySelectorAll('.quick-buy-simple .HorizontalList__Item').forEach(item => {
          if (item.dataset.color === event.target.value) {
            item.style.display = 'inline-block';
          } else {
            item.style.display = 'none';
          }
        });
      }
    });
  });

  // Quick Buy button functionality
  document.querySelectorAll('.list-button').forEach(listButton => {
    listButton.addEventListener('click', event => {
      showListButton(listButton)
    });
  });

  // Plus Button functionality
  document.querySelectorAll('.plusButton').forEach(function(button) {
    button.addEventListener('click', handleQBPlusClick);
    button.addEventListener('touchend', handleQBPlusClick); // For mobile devices
  });

  function serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf('[');

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};
      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === '' || formElement.disabled) {
        continue;
      }

      if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = extend(hash, stringKeys);
      }
    }

    return hash;
  }

  // Extend function to merge objects (similar to your Form.extend method)
  function extend(target, source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        if (target[key] && typeof target[key] === 'object' && typeof source[key] === 'object') {
          target[key] = extend(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
    return target;
  }

  function handleQBPlusClick(event) {
    event.preventDefault();  // Prevents default action for touchend or click
    var targetDiv = document.querySelector('.quick-buy-mobile');
    if (targetDiv) {
      targetDiv.innerHTML = '';
      // var sourceDiv = this.nextElementSibling; // Get the sibling div

      var productItem = event.target.closest(".ProductItem")

      if (productItem) {
        var buttonsInSourceDiv = productItem.querySelectorAll('.Button--light');
        buttonsInSourceDiv.forEach(function(button) {
          button.classList.remove('Button--light');  // Remove the light button class
          button.classList.add('Button--dark');  // Add the dark button class
          button.classList.add('qb-mobile-add-button');  // Add the dark button class
        });

        var clonedContent = productItem.cloneNode(true);
        targetDiv.appendChild(clonedContent);
        targetDiv.classList.add('is-active');

        let swatchParent = targetDiv.querySelector(".ProductItem__ColorSwatchList");
        let swatchTarget = targetDiv.querySelector(".qb-swatches");

        if (swatchParent) {
          swatchTarget.appendChild(swatchParent)
          var swatches = targetDiv.querySelectorAll('.ProductItem__ColorSwatchItem');
          if (swatches) {
            swatches.forEach(function(swatch) {
              if (swatch) {
                swatch.addEventListener('click', event => {

                    swatches.forEach(function(swatch) {
                        swatch.querySelector("input").checked = false;
                    });

                    var swatchInput = swatch.querySelector("input")
                    if (swatchInput) {
                      swatchInput.checked = true;
                    }

                    var swatchValue = swatchInput?.getAttribute("value") || "";
                    var swatchVariant = swatchInput?.getAttribute("data-variant-id") || "";
                    var variantAvailable = swatchInput?.getAttribute('data-variant-available');
                    var variantInventory = swatchInput?.getAttribute('data-variant-inventory');
                    var variantCompareAtPrice = swatchInput?.getAttribute('data-variant-compare-at-price');
                    var variantPrice = swatchInput?.getAttribute('data-variant-price');
                    var variantPreOrder = swatchInput?.getAttribute('data-variant-preorder');

                    targetDiv.querySelector(".qb-variant").innerHTML = swatchValue;
                    targetDiv.querySelector(".quick-buy-variant").value = swatchVariant;

                    // Change the button if pre-order, sale, sold output
                    const quickBuyButton = targetDiv.querySelector('.quick-buy-button')
                    var quickBuyButtonMessage = targetDiv.querySelector('.quick-buy-button > .add-to-cart');


                    var productPreOrder = targetDiv.getAttribute('data-product-preorder');

                    showQBSizeList(swatchInput, targetDiv)

                    if (variantAvailable == "true") {
                      targetDiv.querySelector('.quick-buy-simple').classList.remove('hidden')

                      if (productPreOrder || variantPreOrder) {

                        const preOrderMessage = quickBuyButtonMessage.getAttribute('pre-order-message');

                        if (preOrderMessage) {
                          quickBuyButton.classList.remove('hidden')
                          quickBuyButton.classList.remove('disabled')
                          quickBuyButtonMessage.textContent = preOrderMessage;
                        } else {
                          console.warn('pre-order-message attribute not found.');
                        }

                        var productFormPreOrderProperty = targetDiv.querySelector('.ProductForm__PreOrder textarea');
                        productFormPreOrderProperty.innerHTML = productPreOrder || variantPreOrder;
                        productFormPreOrderProperty.name = 'properties[Estimated Ship Date]';

                      } else {
                        // remove pre-order notes
                        if (quickBuyButtonMessage) {
                          const addToCartMessage = quickBuyButtonMessage.getAttribute('add-to-cart-message');
                          quickBuyButton.classList.remove('hidden')
                          quickBuyButton.classList.remove('disabled')
                          quickBuyButtonMessage.textContent = addToCartMessage;
                        } else {
                          console.warn('add-to-cart-message attribute not found.');
                        }

                        var productFormPreOrderProperty = targetDiv.querySelector('.ProductForm__PreOrder textarea');
                        productFormPreOrderProperty.innerHTML = '';
                        productFormPreOrderProperty.name = '';
                      }
                    } else {
                      // console.log('unavailable')
                      const soldOutMessage = quickBuyButtonMessage.getAttribute('sold-out-message');
                      if (soldOutMessage) {
                        quickBuyButton.classList.remove('hidden')
                        quickBuyButton.classList.add('disabled');
                        quickBuyButtonMessage.textContent = soldOutMessage;
                      } else {
                        targetDiv.querySelector('.quick-buy-simple').classList.add('hidden')
                      }
                    }

                    // Need to account for size options
                    targetDiv.querySelectorAll('.list-button').forEach(listButton => {
                      showListButton(listButton)
                    });

                })
              }
            })
          }
        }

        var buttonstargetDiv = targetDiv.querySelectorAll('.qb-mobile-add-button');
        buttonstargetDiv.forEach(function(button) {
          if (button) {
            button.addEventListener('click', event => {
              event.preventDefault();  // Prevents default action for touchend or click

              var addToCartButton = button // First, we switch the status of the button
              addToCartButton.setAttribute('disabled', 'disabled');
              document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

              var formElement = button.closest('form[action*="/cart/add"]');

              fetch("".concat(window.routes.cartAddUrl, ".js"), {
                body: JSON.stringify(serialize(formElement)),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

                }
              }).then(function (response) {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                var quantityElement = formElement.querySelector('[name="quantity"]');

                if (response.ok) {
                  addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                  targetDiv.classList.remove('is-active');

                  _this4.element.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      variant: _this4.currentVariant,
                      quantity: quantityElement ? parseInt(quantityElement.value) : 1
                    }
                  }));
                } else {
                  response.json().then(function (content) {
                    var errorMessageElement = document.createElement('span');
                    errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                    errorMessageElement.innerHTML = content['description'];
                    addToCartButton.removeAttribute('disabled');
                    addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                    setTimeout(function () {
                      errorMessageElement.remove();
                    }, 2500);
                  });
                }
              });
              event.preventDefault();  // Prevents default action for touchend or click
              // window.Rebuy.SmartCart.show()
            });
          }
        })

        const closeButton = document.querySelector('.quick-buy-mobile .close-quick-buy-mobile-details');
        if (closeButton) {
          closeButton.addEventListener('click', event => {
            const quickBuyMobile = document.querySelector('.quick-buy-mobile');
            if (quickBuyMobile) {
              quickBuyMobile.classList.remove('is-active');
            }
          });
        }

      }

      // if (sourceDiv) {
      //   var buttonsInSourceDiv = sourceDiv.querySelectorAll('.Button--light');
      //   buttonsInSourceDiv.forEach(function(button) {
      //     button.classList.remove('Button--light');  // Remove the light button class
      //     button.classList.add('Button--dark');  // Add the dark button class
      //     button.classList.add('qb-mobile-add-button');  // Add the dark button class
      //   });
      //
      //
      //   var clonedContent = sourceDiv.cloneNode(true);
      //   targetDiv.appendChild(clonedContent);
      //   targetDiv.classList.add('is-active');
      //
      //   var buttonstargetDiv = targetDiv.querySelectorAll('.qb-mobile-add-button');
      //   buttonstargetDiv.forEach(function(button) {
      //     if (button) {
      //       button.addEventListener('click', event => {
      //         event.preventDefault();  // Prevents default action for touchend or click
      //
      //         var addToCartButton = button // First, we switch the status of the button
      //         addToCartButton.setAttribute('disabled', 'disabled');
      //         document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
      //
      //         var formElement = button.closest('form[action*="/cart/add"]');
      //
      //         fetch("".concat(window.routes.cartAddUrl, ".js"), {
      //           body: JSON.stringify(serialize(formElement)),
      //           credentials: 'same-origin',
      //           method: 'POST',
      //           headers: {
      //             'Content-Type': 'application/json',
      //             'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      //
      //           }
      //         }).then(function (response) {
      //           document.dispatchEvent(new CustomEvent('theme:loading:end'));
      //           var quantityElement = formElement.querySelector('[name="quantity"]');
      //
      //           if (response.ok) {
      //             addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
      //             targetDiv.classList.remove('is-active');
      //
      //             _this4.element.dispatchEvent(new CustomEvent('product:added', {
      //               bubbles: true,
      //               detail: {
      //                 variant: _this4.currentVariant,
      //                 quantity: quantityElement ? parseInt(quantityElement.value) : 1
      //               }
      //             }));
      //           } else {
      //             response.json().then(function (content) {
      //               var errorMessageElement = document.createElement('span');
      //               errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
      //               errorMessageElement.innerHTML = content['description'];
      //               addToCartButton.removeAttribute('disabled');
      //               addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
      //               setTimeout(function () {
      //                 errorMessageElement.remove();
      //               }, 2500);
      //             });
      //           }
      //         });
      //         event.preventDefault();  // Prevents default action for touchend or click
      //         // window.Rebuy.SmartCart.show()
      //       });
      //     }
      //   })
      //
      //   const closeButton = document.querySelector('.quick-buy-mobile .close-quick-buy-mobile-details');
      //   if (closeButton) {
      //     closeButton.addEventListener('click', event => {
      //       const quickBuyMobile = document.querySelector('.quick-buy-mobile');
      //       if (quickBuyMobile) {
      //         quickBuyMobile.classList.remove('is-active');
      //       }
      //     });
      //   }
      // }
    }
  }

  // Quick buy swatches click
});
